import React from "react";
import PageWrapper from "./Group.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import GroupTable from "../../components/group/GroupTable";

const Group = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.group"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.group"
          }
        ]}
      />
      <div className="user-tbl">
        <GroupTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state.permissionReducer,
    authData: {
      token: state.auth.token,
      isLogin: state.auth.isLogin,
      profileImage: state.auth.profile_image,
      adminRoleId: state.auth.admin_role_id,
      adminRole: state.auth.admin_role,
      full_name: state.auth.first_name + " " + state.auth.last_name,
      service_id: state.auth.service_id
    }
  };
};

export default connect(mapStateToProps, null)(Group);
